var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgView360 = function SvgView360(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D1F23",
    d: "M12.505 23h2.97C19.64 23 23 21.14 23 16.973v-3.369a.394.394 0 0 0-.646-.298l-3.809 3.245a.239.239 0 0 0 .152.422h1.109c0 2.402-1.953 3.208-4.35 3.208H13.54c-.916 0-1.668.371-1.668 1.293v.893a.633.633 0 0 0 .633.633ZM11.496 1h-2.97C4.36 1 1 2.86 1 7.027v3.369a.394.394 0 0 0 .646.298l3.809-3.245a.238.238 0 0 0-.151-.422H4.176c0-2.402 1.953-3.208 4.35-3.208h1.934c.917 0 1.668-.371 1.668-1.293v-.912A.633.633 0 0 0 11.496 1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2D7DF",
    d: "M14.572 6.569h2.012a.124.124 0 0 1 .124.124v4.904h-2.26V6.693a.124.124 0 0 1 .124-.124Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2D7DF",
    d: "M17.042 10.625H6.958v5.959h10.084v-5.959Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0D1F23",
    d: "M13.834 16.584h-3.667v-2.228a1.16 1.16 0 0 1 .136-.55 1.46 1.46 0 0 1 .397-.467c.17-.134.373-.24.596-.313a2.29 2.29 0 0 1 .704-.11c.486 0 .953.152 1.297.42.343.268.537.632.537 1.011v2.237ZM11.858 4.868 5.79 10.937a.197.197 0 0 0 .142.339h12.137a.198.198 0 0 0 .198-.237.196.196 0 0 0-.056-.102l-6.069-6.069a.202.202 0 0 0-.284 0Z"
  })));
};

export default SvgView360;